import React, { useContext, useEffect, useState } from "react";
import { WidgetProps } from "../widgets";
import AppContext, { IAppContext } from "../../contexts/app/AppContext";
import firewireBg from "../../assets/firewire/firewireBG.png";
import firewirePhone from "../../assets/firewire/firewirePhone.png";
import appstoreIcon from "../../assets/icons/AppStoreWhite.png";
import googlePlayIcon from "../../assets/icons/GooglePlayWhite.png";
import "./FirewireApp.scss";

type BenefitsWidgetProps = {} & WidgetProps;

export const FirewireAppWidget: React.FC<BenefitsWidgetProps> = (props: BenefitsWidgetProps) => {
	const appContext: IAppContext = useContext<IAppContext>(AppContext);
	const { config } = appContext;
	const { iOSlink, androidLink } = config;

	return (
		<div className="section-padding1 firewire-app-outer-container p-0 mb-5">
			<div className="firewire-app-inner-container container section-padding d-flex flex-row">
				<img
					src={firewireBg}
					className="d-none d-md-block"
					style={{ position: "absolute", top: "-23vh", width: "55%", right: 0 }}
				/>
				<div className="w-50 w-100-sm">
					<h1>FireWire App</h1>
					<p className="pt-4">
						The Firewire App, created by our own Los Angeles County Benefit and Welfare Association, serves
						as a member portal, resource, and convenient mobile experience.
					</p>
					<p className="py-3 pb-2">
						New members can quickly verify their employment in Firewire once downloaded. Access all your B&W
						membership benefits on the go.
						{/*<a*/}
						{/*	className="text-black text-underline arrow-link w-100 d-inline-flex align-items-center pt-3 mt-1"*/}
						{/*	target="_blank"*/}
						{/*	href="https://firewireapp.com/"*/}
						{/*>*/}
						{/*	Learn more*/}
						{/*</a>*/}
					</p>
					<div className="app-links d-flex flex-row">
						<a href={iOSlink} target="_blank">
							<img className="white" src={appstoreIcon} />
						</a>
						<a href={androidLink} target="_blank">
							<img className="white" src={googlePlayIcon} />
						</a>
					</div>
				</div>
				<div className="position-relative w-50 d-none d-md-block">
					<img
						src={firewirePhone}
						style={{
							position: "absolute",
							top: "-150px",
							width: "42vh",
							maxWidth: "400px",
							minWidth: "380px",
							right: "10%",
						}}
					/>
				</div>
			</div>
		</div>
	);
};
